import { Routes } from '@angular/router';
import { CreatePasswordPage } from './pages/create-password-page/create-password-page';
import { ForgotPasswordPage } from './pages/forgot-password-page/forgot-password-page';
import { LoginPage } from './pages/login-page/login-page';
import { RegistrationPage } from './pages/registration-page/registration-page';
import { LandingPageComponent } from './pages/landing-four/landing-page.component';
// import { WorkflowLandingComponent } from './pages/workflow/workflow-landing/workflow-landing.component';
import { SettingLandingComponent } from './pages/settings/setting-landing/setting-landing.component';
// import { UserDashboardComponent } from './pages/dashboard/user-dashboard/user-dashboard.component';
import { UserDashboardShellComponent } from './pages/user/user-dashboard/user-dashboard-shell.component';
import { UserVendorsComponent } from './pages/user/user-dashboard/user-vendors.component';
// import { UserAssessmentsComponent } from './pages/user/user-dashboard/user-assessments.component';
import { AdminDashboardComponent } from './pages/dashboard/admin-dashboard/admin-dashboard.component';
// import { AssessmentLandingComponent } from './pages/assessment/assessment-landing/assessment-landing.component';
import { VendorLandingComponent } from './pages/vendors/vendor-landing/vendor-landing.component';
import { VendorWizardComponent } from './pages/vendors/vendor-wizard/vendor-wizard.component';
import { authGuardsGuard } from './modules/guards/auth-guards.guard';
import { roleGuardsGuard } from './modules/guards/role-guards.guard';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ReportsLandingComponent } from './pages/reports/reports-landing/reports-landing.component';
import { ApprovalsLandingComponent } from './pages/approvals/approvals-landing/approvals-landing.component';
import { Intranet } from './layout/intranet/intranet';
import { MakePaymentModal } from './pages/payments/make-payment-modal/make-payment-modal.component';
import { PaymentVerificationComponent } from './pages/payments/payment-verification/payment-verification.component';
import { SearchVendorPayments } from './pages/payments/search-payments/search-payments.component';
import { guestGuard } from './modules/guards/guest/guest-guard.guard';
import { PublicVerifyDocumentComponent } from './pages/public/verify-document/public-verify-document.component';
import { accountTypeGuard } from './modules/guards/account-type/account-type-guard.guard';

export const routes: Routes = [
  {
    path: 'public',
    children: [
      {
        path: 'verify-document',
        component: PublicVerifyDocumentComponent,
      },
    ],
  },
  {
    path: "",
    canActivate: [guestGuard],
    children: [
      { path: '', component: LandingPageComponent },
      { path: 'landing-four', component: LandingPageComponent },
      { path: 'login', component: LoginPage },
      { path: 'forgot-password', component: ForgotPasswordPage },
      { path: 'create-password', component: CreatePasswordPage },
      { path: 'register', component: RegistrationPage }
    ]
  },
  {
    path: 'admin',
    canActivate: [authGuardsGuard, accountTypeGuard],
    component: Intranet,
    data: {
      accountType: 'ADMIN'
    },
    children: [
      {
        path: '',
        redirectTo: "dashboard",
        pathMatch: "full"
      },
      {
        path: 'settings/landing',
        component: SettingLandingComponent,
        canActivate: [roleGuardsGuard],
        data: {
          permissions: [],
        },
      },
      {
        path: 'dashboard',
        component: AdminDashboardComponent,
        canActivate: [roleGuardsGuard],
        data: {
          permissions: [],
        },
      },
      {
        path: 'dashboard2',
        component: DashboardComponent,
        canActivate: [roleGuardsGuard],
        data: {
          permissions: [],
        },
      },
      // {
      //   path: 'assessments',
      //   component: AssessmentLandingComponent,
      //   canActivate: [roleGuardsGuard],
      //   data: {
      //     permissions: ['CAN_APPROVE_Role_Management'],
      //   },
      // },
      {
        path: 'vendors',
        component: VendorLandingComponent,
        canActivate: [roleGuardsGuard],
        data: {
          permissions: ['CAN_VIEW_Vendor_Management'],
        },
      },
      {
        path: 'vendors/new',
        component: VendorWizardComponent,
        canActivate: [roleGuardsGuard],
        data: {
          permissions: ['CAN_CREATE_Vendor_Management'],
        },
      },
      {
        path: 'vendors/:id/edit',
        component: VendorWizardComponent,
        canActivate: [roleGuardsGuard],
        data: {
          permissions: ['CAN_EDIT_Vendor_Management'],
        },
      },
      {
        path: 'html-playground',
        redirectTo: 'dashboard',
      },
      {
        path: 'reports',
        component: ReportsLandingComponent,
        canActivate: [roleGuardsGuard],
        data: {
          permissions: ['CAN_APPROVE_Reports___Analytics', 'CAN_VIEW_Reports___Analytics'],
        },
      },
      {
        path: 'approvals',
        component: ApprovalsLandingComponent,
        canActivate: [roleGuardsGuard],
        data: {
          permissions: ['CAN_APPROVE_Vendor_Management'],
        },
      },
      {
        path: 'payments',
        canActivate: [roleGuardsGuard],
        data: {
          permissions: ['CAN_APPROVE_Payments_Management', 'CAN_VIEW_Payments_Management'],
        },
        children: [
          {
            path: '',
            component: SearchVendorPayments
          },
        ]
      }
    ],
  },
  {
    path: 'user',
    canActivate: [authGuardsGuard, accountTypeGuard],
    data: {
      accountType: 'USER'
    },
    children: [
      {
        path: '',
        redirectTo: 'vendors',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        redirectTo: 'vendors',
        pathMatch: 'full',
      },
      {
        path: '',
        component: UserDashboardShellComponent,
        canActivate: [roleGuardsGuard],
        data: {
          permissions: ['CAN_VIEW_Vendor_Management'],
        },
        children: [
          {
            path: 'vendors',
            children: [
              {
                path: '',
                component: UserVendorsComponent,
              },
              {
                path: 'new',
                component: VendorWizardComponent,
                canActivate: [roleGuardsGuard],
                data: {
                  permissions: ['CAN_CREATE_Vendor_Management'],
                },
              },
               {
                path: ':id/edit',
                component: VendorWizardComponent,
                canActivate: [roleGuardsGuard],
                data: {
                  permissions: ['CAN_EDIT_Vendor_Management'],
                },
              },
            ]
          },
          // {
          //   path: 'assessments',
          //   component: UserAssessmentsComponent,
          // },
        ],
      },
      {
        path: 'payment',
        children: [
          {
            path: 'return-back/:txnref',
            component: PaymentVerificationComponent,
          },
          {
            path: 'make-payment/:id',
            component: MakePaymentModal,
          }
        ]
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
